import { useState } from "react";
import { fmtDateTime } from "../../lib/api";
import { useApi, Loading, inputCls, Empty } from "../../components/kit";

const ENTITIES = ["", "user", "assignment", "acknowledgement", "course", "course_map", "certificate", "signoff", "sds", "safety_report", "policy", "settings", "role", "link"];

export default function Audit() {
  const [entity, setEntity] = useState("");
  const [action, setAction] = useState("");
  const { data, loading } = useApi(`/audit?entity=${entity}&action=${encodeURIComponent(action)}`);
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">Append-only. Entries are never edited or removed. Times in Ottawa time.</p>
      <div className="flex flex-wrap gap-2">
        <select className={`${inputCls} max-w-xs`} aria-label="Entity" value={entity} onChange={(e) => setEntity(e.target.value)} data-testid="audit-entity-filter">{ENTITIES.map((x) => <option key={x} value={x}>{x || "All records"}</option>)}</select>
        <input className={`${inputCls} max-w-xs`} placeholder="Action contains… e.g. reporting_line" aria-label="Action filter" value={action} onChange={(e) => setAction(e.target.value)} data-testid="audit-action-filter" />
      </div>
      {loading ? <Loading /> : (data || []).length === 0 ? <Empty>No entries.</Empty> : (
        <div className="overflow-x-auto rounded-2xl border bg-white">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead><tr className="border-b text-left"><th className="p-3">When</th><th className="p-3">Who</th><th className="p-3">Action</th><th className="p-3">Details</th></tr></thead>
            <tbody>{data.map((a) => (
              <tr key={a.id} className="border-b last:border-0 align-top">
                <td className="p-3 whitespace-nowrap">{fmtDateTime(a.at)}</td><td className="p-3">{a.actor_name}</td><td className="p-3 font-mono text-xs">{a.action}</td>
                <td className="p-3 text-xs text-muted-foreground break-all max-w-md">{JSON.stringify(a.detail)}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
